import React, {
  useState,
  useEffect
} from 'react';
import { observer } from "mobx-react"

import { makeStyles } from '@material-ui/core/styles';
import {
  Avatar,
  ButtonBase,
  Chip,
  Tooltip,
  Typography,
  colors,
} from '@material-ui/core';
import { grey } from '@material-ui/core/colors';

import {
  ObservableAPI,
} from '../../../data/ObservableAPI';
import {
  User
} from '../../../types';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'left',
  },
  avatar: {
    marginRight: 10,
  },
  nameContainer: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
  },
  line1: {
    minWidth: 120,
  },
  line2: {
    color: colors.grey[500],
  }
}));

interface PropType {
  user?: User;
  id?: string;
  role?: string;
  className?: string;
  line2?: string;
  hideLine2?: boolean;
  to?: string;
  component?: any;
  onClick?: () => void;
};


function UserViewComponent(props: PropType) {
  const classes = useStyles();
  const [user, setUser] = useState(props.user);

  const loadProfileData = async (id: string, role: string) => {
    const api = new ObservableAPI();
    const url = `${role}/${id}/`;
    try {
      const result = await api.get(url);
      if (result && (result as any).id) {
        setUser(result as User);
      }; 
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (props.id && props.role) loadProfileData(props.id, props.role);
  }, [props.id, props.role])

  const eventId = (props.id && props.role) ? `user-${props.id}` : `user-${props.user?.id}`;

  if (user) {
    const line2 = props.line2 ? (user as any)[props.line2] : '';
    const extraProps: any = {};
    if (props.to && props.component) {
      extraProps.to = props.to;
      extraProps.component = props.component;
    }

    if (props.onClick) {
      extraProps.onClick = props.onClick;
    }

    return (
      <ButtonBase
        className={`${classes.root} ${props.className}`}
        {...extraProps}
      >
        <Avatar src={user.avatar} className={classes.avatar} />
        <div className={classes.nameContainer}>
          <Typography variant="body1" className={classes.line1}>{user.full_name}</Typography>
          {!props.hideLine2 && <Typography variant="body2" className={classes.line2}>{line2}</Typography>}
        </div>
      </ButtonBase>
    );
  }
  return (<></>)
}

const UserView = observer(UserViewComponent);
export {UserView, UserViewComponent};